import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingLiveArea } from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** Below this an area reads as weak (two stars start here). */
const kWeakScore = 60;

/** One area's name and score over its bar; a weak one shows amber. */
export const AreaScoreBar = memo(({ area }: { area: CoachingLiveArea }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View style={{ gap: rpx(4) }}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: rpx(6),
        }}
      >
        <Typography.Text
          size={rpx(12)}
          color={aiColors.foreground}
          numberOfLines={1}
          style={{ flex: 1 }}
        >
          {area.name}
        </Typography.Text>
        <Typography.Text size={rpx(12)} bold color={aiColors.foreground}>
          {area.score}
        </Typography.Text>
      </View>
      <View
        style={{
          height: rpx(6),
          borderRadius: rpx(3),
          overflow: 'hidden',
          backgroundColor: aiColors.muted,
        }}
      >
        <View
          style={{
            width: `${Math.max(0, Math.min(area.score, 100))}%`,
            height: '100%',
            borderRadius: rpx(3),
            backgroundColor:
              area.score < kWeakScore ? aiColors.amber : aiColors.primary,
          }}
        />
      </View>
    </View>
  );
});
